require ('./aggregatorAddEntityStepSelectBank.scss')

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import OKSelect from 'components/commons/OKSelect/OKSelect';
import { CSSTransition } from 'react-transition-group';


class AggregatorAddEntityStepSelectBank extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            imagesLoaded: Array(8).fill().map(() => false),
            inPropImg: Array(8).fill().map(() => false),
            inPropEmpty: Array(8).fill().map(() => true)
        }
    }

    componentWillMount(){
        this.props.getBanks()
    }

    selectBank = async (selectedBank, goToNexStep) => {
        const { selectBank, getDataBank, validateStep } = this.props;
        const bankCode = selectedBank ? selectedBank.get('id') : ''
        
        await getDataBank(bankCode)
        await selectBank(selectedBank)
        
        if (goToNexStep) {
            validateStep(1)
        }
    }

    getSelectOptions = () => {
        const { banks } = this.props
        if (!banks) return []
        if (Array.isArray(banks)) return banks
        return banks.map(bank => ({value: bank.get('id'), label: bank.get('text'), bank})).toArray()
    }

    renderBanks = () => {
        const { banks, selectedBank } = this.props
        const { inPropEmpty, inPropImg } = this.state

        const mainBanks = (banks || Array(8).fill()).filter(b => b ? b.get('showOnGrid') : true)

        const getClassName =(id) =>
            classNames('aggregator-add-entity__wizard__wizard-step-select-bank__content__item ',
                {
                    "aggregator-add-entity__wizard__wizard-step-select-bank__content__item--active": selectedBank === id
                })

        const getImgClassName =(id) =>
            classNames("aggregator-add-entity__wizard__wizard-step-select-bank__content__item__image",
                {
                    "aggregator-add-entity__wizard__wizard-step-select-bank__content__item__image--active": selectedBank === id
                })

        return  (
            <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content__banks">
                <div className="row">
                    {(mainBanks).map((bank, i) => (
                        <div key={i} className="col-xs-12 col-sm-3">
                            <div
                                className={getClassName(bank && bank.get('id'))}
                                onClick={() => this.selectBank(bank, true)}
                            >
                                <CSSTransition
                                    in={inPropEmpty[i]}
                                    timeout={200}
                                    classNames="animate-empty"
                                    unmountOnExit
                                    onExited={() => {
                                        this.setState({
                                            inPropImg: inPropImg.map((itm, index) => index == i ? true : itm),
                                        });
                                    }}
                                >
                                    <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content__item__empty-img">
                                    </div>
                                </CSSTransition>
                                <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content__item__icon__div">
                                    <i className="aggregator-add-entity__wizard__wizard-step-select-bank__content__item__icon__icon icon icon-exito" />
                                </div>
                                <CSSTransition
                                    in={inPropImg[i]}
                                    timeout={500}
                                    classNames="animate-img"
                                >
                                    <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content__item__img-div">

                                        <img
                                            onLoad={() => this.setState({inPropEmpty: inPropEmpty.map((itm, index) => index == i ? false : itm)})}
                                            className={getImgClassName(bank && bank.get('id'))}
                                            src={bank && bank.get('url')}
                                            alt={bank && bank.get('text')}
                                        />
                                    </div>
                                </CSSTransition>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    render() {
        const { selectedBank } = this.props

        return (
            <div className="aggregator-add-entity__wizard__wizard-step-select-bank">
                <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content">
                    {this.renderBanks()}
                    <div className="aggregator-add-entity__wizard__wizard-step-select-bank__content__search">
                        <OKSelect
                            label="aggregatorAddEntity-selectBankSelectorLabel"
                            value={selectedBank}
                            onChange={selectedOption => this.selectBank(selectedOption.bank, false)}
                            options={this.getSelectOptions()}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


AggregatorAddEntityStepSelectBank.propTypes = {
    banks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            showOnGrid: PropTypes.bool,
            url: PropTypes.string
        })
    ),
    selectedBank: PropTypes.string,
    selectBank: PropTypes.func,
    getBanks: PropTypes.func,
    getDataBank: PropTypes.func.isRequired,
    isFetching: PropTypes. bool,
    validateStep: PropTypes.func
}

AggregatorAddEntityStepSelectBank.defaultProps = {
    banks: [],
    selectedBank: null,
    isFetching: false
}

export { AggregatorAddEntityStepSelectBank }